import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '1rem',
      '@media (max-width: 768px)': {
        flexDirection: 'column'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
